import * as React from 'react';
import Helmet from 'react-helmet';
import { ErrorBoundary } from '../errorHandling/ErrorBoundary';

type Script = {
  type: string;
  source: string;
  name: string;
  async: boolean;
  attributes?: object;
};

type ExternalScriptsProps = {
  scripts: Array<Script>;
};

function createScriptTag({ type, source, async, name, attributes = {} }: Script) {
  if (type === 'URL' && source.length > 0) {
    return <script async={async} src={source} type="text/javascript" key={name} {...attributes} />;
  }

  // TODO - add html sanitization in the builder side or here...
  if (type === 'code' && source.length > 0) {
    return (
      <script type="text/javascript" key={name} {...attributes}>{source}</script>
    );
  }

  return null;
}

export const ExternalScriptsComponent = ({ scripts }: ExternalScriptsProps) => {
  return (
    <Helmet>
      {scripts.map(createScriptTag)}
    </Helmet>
  );
};

export const ExternalScripts = (props: ExternalScriptsProps) => (
  <ErrorBoundary>
    <ExternalScriptsComponent {...props} />
  </ErrorBoundary>
);
